import { useEffect } from 'react';
import { useHierarchyContext } from '../hooks/useHierarchyContext';
import { useParams } from 'react-router-dom';
import { useDidUpdateEffect } from '../../hooks/useDidUpdateEffect';
import { dlItemsViewListEvent } from '../../events/dl.Items.viewList.event';
import { collectionData, defaultSearchParams, templateSuffix } from '../configs';
export const DLCollectionData = () => {
    const { handle } = useParams();
    const { objects } = useHierarchyContext();
    useDidUpdateEffect(() => {
        const obj = objects[handle ?? ''];
        if (obj === undefined)
            return;
        window.dataLayer.push({
            collection: {
                id: obj.id,
                name: obj.fullName,
                path: `/collections/${obj.handle}`
            },
            content: {
                handle: obj.handle
            }
        });
    }, [objects]);
    useEffect(() => {
        const obj = objects[handle ?? ''];
        dlItemsViewListEvent([{
                name: obj?.fullName ?? collectionData.title,
                path: obj?.facetValue,
                type: templateSuffix,
                filter: defaultSearchParams.filters
            }]);
    }, [objects]);
    return null;
};
